import { API_BASE } from './api';

const CHECKIN_API = `${API_BASE}/checkin`;

export async function fetchQuestions() {
  const res = await fetch(`${CHECKIN_API}/questions`, {
    credentials: 'include',
  });

  if (!res.ok) throw new Error('Failed to load check-in questions.');
  return res.json();
}

export async function submitCheckIn(payload) {
  const body =
    payload && payload.answers
      ? payload
      : { answers: payload };

  const res = await fetch(`${CHECKIN_API}/submit`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify(body),
  });

  const data = await res.json();

  if (!res.ok) {
    throw new Error(data.message || 'Failed to submit check-in.');
  }

  return data;
}

export async function emailCheckInResult(email, assessment, selectedSections) {
  const res = await fetch(`${CHECKIN_API}/email-result`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify({ email, assessment, selectedSections }),
  });

  const data = await res.json();

  if (!res.ok) {
    throw new Error(data.message || 'Failed to send result email.');
  }

  return data;
}

// for ac 4.2.2
export async function fetchCheckInHistory() {
  const res = await fetch(`${CHECKIN_API}/history`, {
    method: "GET",
    credentials: "include",
  });

  const data = await res.json();

  if (!res.ok) {
    throw new Error(data.message || "Failed to load check-in history.");
  }

  return data;
}


// for saving result
export async function saveCheckInResult(resultPayload) {
  const res = await fetch(`${CHECKIN_API}/save-result`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
    body: JSON.stringify(resultPayload),
  });

  const data = await res.json().catch(() => ({}));

  if (!res.ok) {
    throw new Error(data.message || "Failed to save check-in result.");
  }

  return data;
}

// for ac 4.2.3
export async function fetchCheckInResultDetail(resultId) {
  const res = await fetch(`${CHECKIN_API}/history/${resultId}`, {
    method: "GET",
    credentials: "include",
  });

  const data = await res.json();

  if (!res.ok) {
    throw new Error(data.message || "Failed to load check-in result detail.");
  }

  return data;
}